import React from 'react';
import {Flex} from '@tempo/core';
import Header from '@components/Header';
import {useTranslation} from 'next-i18next';
import CustomHeading from '@components/Templates/elements/CustomHeading';

const Unlogged = () => {
	const {t} = useTranslation();
	return (
		<Flex h="full" w="full" justifyContent="center" alignItems="center">
			<Header color="#FFFFFF" muteAction={false} cardId="unlogged" />
			<CustomHeading
				customContext="PageTitle"
				dangerouslySetInnerHTML={{
					__html: t('mydeezeryearerrormessage_text_logintostartexperience_web'),
				}}
				textAlign="center"
			/>
		</Flex>
	);
};

export default Unlogged;
